import { Container, Application } from 'pixi.js';

export abstract class Scene extends Container {
  app: Application;

  constructor(app: Application) {
    super();
    this.app = app;
  }

  abstract onEnter(): void;
  abstract onExit(): void;
  abstract update(dt: number): void;
}

export class SceneManager {
  private app: Application;
  private scenes = new Map<string, Scene>();
  private currentScene: Scene | null = null;
  private currentName = '';

  constructor(app: Application) {
    this.app = app;
  }

  add(name: string, scene: Scene) {
    this.scenes.set(name, scene);
  }

  switchTo(name: string) {
    const scene = this.scenes.get(name);
    if (!scene) {
      console.error(`[SceneManager] Cena '${name}' nao encontrada`);
      return;
    }

    if (this.currentScene) {
      this.currentScene.onExit();
      this.app.stage.removeChild(this.currentScene);
    }

    this.currentScene = scene;
    this.currentName = name;
    this.app.stage.addChild(scene);
    scene.onEnter();
  }

  update(dt: number) {
    if (this.currentScene) {
      this.currentScene.update(dt);
    }
  }

  getCurrentName(): string {
    return this.currentName;
  }
}
